import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export enum EmployerMarketSegment {
    Micro = 'MICRO',
    Small = 'SMALL',
    Medium = 'MEDIUM',
    Large = 'LARGE',
    Premium = 'PREMIUM',
    Undefined = 'UNDEFINED',
}

export enum PromoCodeStatus {
    Active = 'ACTIVE',
    Pending = 'PENDING',
    Expired = 'EXPIRED',
    Exhausted = 'EXHAUSTED',
}

export interface PromoCodeBonus {
    sum: number;
}

export interface PromoCodeBound {
    employerIds?: number[] | null;
    employerMarketSegments?: EmployerMarketSegment[] | null;
}

export interface PromoCode {
    promoCode: string;
    description: string;
    bonus: PromoCodeBonus;
    startDate: string | null;
    endDate: string | null;
    activationsLimit: number | null;
    activationsCount: number;
    bound?: PromoCodeBound | null;
    status: PromoCodeStatus; // вычисляется на фронтенде
}

export type PromoCodeDTO = Omit<PromoCode, 'status'>;

// ----------------------- actions -------------------------------------
const SET_PROMO_CODES = 'SET_PROMO_CODES';
const UPDATE_PROMO_CODE = 'UPDATE_PROMO_CODE';
const ADD_PROMO_CODE = 'ADD_PROMO_CODE';

interface PayloadTypes {
    [SET_PROMO_CODES]: PromoCode[];
    [UPDATE_PROMO_CODE]: Partial<PromoCode> & { promoCode: string };
    [ADD_PROMO_CODE]: PromoCode;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setPromoCodes = ActionCreator(SET_PROMO_CODES);
export const updatePromoCode = ActionCreator(UPDATE_PROMO_CODE);
export const addPromoCode = ActionCreator(ADD_PROMO_CODE);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
export interface PromoCodesState {
    promoCodes: PromoCode[];
}

const PROMO_CODES_INITIAL_STATE: PromoCodesState = {
    promoCodes: [],
};

export default createReducer<PromoCodesState, PayloadTypes>(PROMO_CODES_INITIAL_STATE, {
    [SET_PROMO_CODES]: (state, { payload }) => ({
        ...state,
        promoCodes: payload,
    }),
    [UPDATE_PROMO_CODE]: (state, { payload }) => ({
        ...state,
        promoCodes: state.promoCodes.map((promoCode) =>
            promoCode.promoCode === payload.promoCode ? { ...promoCode, ...payload } : promoCode
        ),
    }),
    [ADD_PROMO_CODE]: (state, { payload }) => ({
        ...state,
        promoCodes: [payload, ...state.promoCodes],
    }),
});
// ----------------------- /reducer --------------------------------------
